import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../models/user-profile.model';
import { RoleAccess } from '../../models/role-access.model';
import { NavController, ToastController } from '@ionic/angular';
import { UserData } from '../../providers/user-data';
import { NavigationExtras, Router } from '@angular/router';
import { UtilService } from '../../service/util.service';
import { HttpClient } from '@angular/common/http';
import { TierService } from './tier.service';
import AES = require('crypto-js/aes');
import { environment } from '../../../environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-tier',
  templateUrl: './tier.page.html',
  styleUrls: ['./tier.page.scss'],
})
export class TierPage implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };
  keywordSearch:any='';
  rows:any;
  tierList: any[]=[];
  filteredData: any;
  constructor(
      private storage: Storage,
      private toastCtrl: ToastController,
      private userData: UserData,
      private router: Router,
      private navCtrl: NavController,
      private utilService:UtilService,
      private http: HttpClient,
      private tierService:TierService
    ) { }

  ngOnInit() {
  }
  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        } 
        this.pageCallback({ offset: this.page.offset });
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  
  sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable();
  }

  reloadTable() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "keyword": this.keywordSearch
      };
      this.tierService.getTierList(options)
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        this.page.count = response.results.total;
        this.rows = response.results.data;
        this.filteredData = response.results.data;
        this.tierList = response.data_no_limit;
      }, (err) => {
        this.utilService.loadingDismiss();
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }
  searchTier(event) {
    this.keywordSearch= event.target.value.toLowerCase();
    this.reloadTable();
  }
  goToTierCreate() {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(0),myKey).toString();
    let encryptType = AES.encrypt('add',myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptType
      }
    };
    this.navCtrl.navigateForward(['/tier/tier-form'], navigationExtras);
  }

  goToUpdatePage(id: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let encryptType = AES.encrypt('update',myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptType
      }
    };
    this.navCtrl.navigateForward(['/tier/tier-form'], navigationExtras);
  }
  goToTierDetail(id:any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let encryptType = AES.encrypt('detail',myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptType
      }
    };
    this.navCtrl.navigateForward(['/tier/tier-form'], navigationExtras);
  }
  exportToExcel() {
    let dataForExport = [];
    if(this.tierList.length>0){
      for(let i=0;i<this.tierList.length;i++){
        dataForExport.push(
          { No: (i+1), 
            "Tier Name": this.tierList[i].tier_name, 
            "Spend to Reach": this.tierList[i].spend_to_reach,
            "Spend to Keep": this.tierList[i].spend_to_keep ,
            "Created At":this.tierList[i].created_at,
            "Created By":this.tierList[i].created_by,
            "Updated At":this.tierList[i].updated_at,
            "Updated By":this.tierList[i].updated_by},
        );
      }
    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExport);
    const objectMaxLength: number[] = [];
    dataForExport.forEach(row => {
      Object.values(row).forEach((value, colIndex) => {
        const length = String(value).length;
        objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, length);
      });
    });
    Object.keys(dataForExport[0]).forEach((header, colIndex) => {
      objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, header.length);
    });
    ws['!cols'] = objectMaxLength.map(width => ({ wch: width + 2 }));
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Tier.xlsx');
  }
}
